import { Container, Graphics } from 'pixi.js-legacy';
import type { BossDeathEffect } from '../../entities/BossDeathEffect';

/**
 * BossDeathEffect PixiJS 어댑터
 * (이펙트 수명이 짧아서 원래 방식 유지 - scale 사용 시 stroke 두께가 같이 커지는 문제)
 */
export class BossDeathEffectAdapter {
    private container: Container;
    private active: Map<BossDeathEffect, Graphics> = new Map();

    constructor(container: Container) {
        this.container = container;
    }

    sync(effects: BossDeathEffect[]): void {
        const effectSet = new Set(effects);

        // 비활성화된 이펙트 제거
        for (const [effect, g] of this.active) {
            if (!effect.getIsActive() || !effectSet.has(effect)) {
                g.destroy();
                this.active.delete(effect);
            }
        }

        // 활성 이펙트 업데이트/추가
        for (const effect of effects) {
            if (effect.getIsActive()) {
                if (!this.active.has(effect)) {
                    const g = new Graphics();
                    this.container.addChild(g);
                    this.active.set(effect, g);
                }

                this.updateEffect(effect);
            }
        }
    }

    private updateEffect(effect: BossDeathEffect): void {
        const g = this.active.get(effect);
        if (!g) return;

        g.clear();

        const circles = effect.getCircles();
        const elapsed = effect.getElapsed();

        for (const circle of circles) {
            if (circle.currentRadius <= 0 || circle.alpha <= 0) continue;
            if (elapsed < circle.delay) continue;

            if (circle.phase === 'growing') {
                // 채워진 상태
                g.beginFill(0xFFFFFF, circle.alpha * 0.6);
                g.drawCircle(circle.x, circle.y, circle.currentRadius);
                g.endFill();

                g.lineStyle(2, 0xFFFFFF, circle.alpha);
                g.drawCircle(circle.x, circle.y, circle.currentRadius);
            } else {
                // 외곽선만
                g.lineStyle(2, 0xFFFFFF, circle.alpha);
                g.drawCircle(circle.x, circle.y, circle.currentRadius);
            }
        }
    }

    clear(): void {
        for (const [, g] of this.active) {
            g.destroy();
        }
        this.active.clear();
    }

    reset(): void {
        // clearAll()로 이미 컨테이너에서 제거되었으므로 참조만 정리
        // (Graphics는 PixiLayers.destroyChildren에서 이미 destroy됨)
        this.active.clear();
    }

    destroy(): void {
        this.clear();
    }
}
